<template>
  <div>
    <router-view @makeToasts="makeToasts"></router-view>
    <b-modal hide-footer :title="$t(confTitle)" ref="modalConfirmation">
      <h5>{{ $t(confBody) }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="okConfirmation()">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="$refs.modalConfirmation.hide()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      confTitle: '',
      confBody: '',
      confFunc: null,
      confData: null
    }
  },
  methods: {
    makeToasts (variant = 'success', body = this.$t('Success'), title = '') {
      this.$bvToast.toast(body, {
        variant: variant,
        title: title,
        solid: true,
        autoHideDelay: 7000
      })
    },
    showConfirmation (title, body, func, funcData) {
      this.confTitle = title
      this.confBody = body
      this.confFunc = func
      this.confData = funcData
      this.$refs.modalConfirmation.show()
    },
    okConfirmation () {
      this.$refs.modalConfirmation.hide()
      this.confFunc(this.confData)
    }
  },
  mounted () {
    this.$root.$on('makeToasts', this.makeToasts)
    this.$root.$on('showConfirmation', this.showConfirmation)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/Content.vue